import { useEffect, useRef, useState } from "react";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import { Swiper, SwiperSlide } from "swiper/react";
import Backdrop from "../Backdrop";
import { CatalogItem } from "../../types/principal";
import { useStyles } from "./styles";

type CatalogProps = {
  items: CatalogItem[];
  title?: string;
  labelButton?: string;
  whatsapp: string;
};

const Catalog = ({ items, title, labelButton, whatsapp }: CatalogProps) => {
  if (Array.isArray(items) && items.length > 0) {
    const sliderRef = useRef(null);
    const theme = useTheme();
    const styles = useStyles();

    const [openBackdrop, setOpenBackdrop] = useState<boolean>(false);
    const [offer, setOffer] = useState();
    const [slideConfig, setSlideConfig] = useState({
      isBeginning: true,
      isEnd: false,
    });

    const handlePrev = () => {
      if (!sliderRef.current) return;
      //@ts-ignore
      sliderRef.current.swiper.slidePrev();
    };

    const handleNext = () => {
      if (!sliderRef.current) return;
      //@ts-ignore
      sliderRef.current.swiper.slideNext();
    };

    const handleNavigate = (message: string) => {
      const url = `https://wa.me/${whatsapp}?text=${message}`;
      window.open(url, "_blank");
    };

    const handleChangeBackdrop = (image?: any) => {
      setOffer(image);
      setOpenBackdrop((prev) => !prev);
    };

    useEffect(() => {
      if (!sliderRef.current) return;

      //@ts-ignore
      sliderRef.current.swiper.on("slideChange", (swipe: any) => {
        setSlideConfig({ isBeginning: swipe.isBeginning, isEnd: swipe.isEnd });
      });
      //@ts-ignore
    }, [sliderRef.current?.swiper]);

    return (
      <section id="catalog">
        <Stack rowGap={2}>
          {title && (
            <Typography color="primary" variant="h6" fontWeight={500}>
              {title}
            </Typography>
          )}
          {Array.isArray(items) && items.length > 0 && (
            <Container maxWidth="sm" style={{ padding: 0 }}>
              <Swiper
                //@ts-ignore
                ref={sliderRef}
                spaceBetween={10}
                slidesPerView={1.5}
              >
                {items.map((item, index) => (
                  <SwiperSlide key={index.toString()}>
                    <Card elevation={0} sx={{ height: 300 }}>
                      <Stack height="100%" rowGap={2}>
                        <CardMedia
                          sx={{
                            height: 180,
                            cursor: "pointer",
                            flex: 1,
                            display: "flex",
                          }}
                          image={item.image}
                          title={`product-${index}`}
                          onClick={() => {
                            handleChangeBackdrop(item);
                          }}
                        />

                        <Stack rowGap={1} px={2}>
                          {item.title && (
                            <Typography
                              color="secondary"
                              fontWeight={600}
                              noWrap
                            >
                              {item.title}
                            </Typography>
                          )}
                          {item.description && (
                            <div className={styles.containerDescription}>
                              <Typography color="secondary" variant="button">
                                {item.description}
                              </Typography>
                            </div>
                          )}
                        </Stack>

                        <Stack
                          px={1}
                          direction="row"
                          pb={1}
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          {labelButton && (
                            <Button
                              onClick={() => {
                                if (item.href) {
                                  window.open(item.href, "_blank");
                                } else {
                                  handleNavigate(
                                    `${labelButton} ${item.title}`
                                  );
                                }
                              }}
                              color="secondary"
                              disableTouchRipple={false}
                            >
                              {labelButton}
                            </Button>
                          )}
                          {item.endDate && (
                            <Typography
                              noWrap
                              color="secondary"
                              variant="caption"
                              fontWeight={600}
                            >
                              Válido até {item.endDate}
                            </Typography>
                          )}
                        </Stack>
                      </Stack>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
              <Stack mt={2} direction="row" spacing={2}>
                <IconButton
                  disableTouchRipple
                  size="small"
                  aria-label="previous"
                  onClick={handlePrev}
                  disabled={slideConfig.isBeginning}
                  sx={{
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.secondary.main,
                    "&:hover": {
                      backgroundColor: theme.palette.primary.main,
                    },
                    "&:disabled": {
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.secondary.main,
                      opacity: 0.4,
                    },
                  }}
                >
                  <i className="fi fi-rr-arrow-small-left" />
                </IconButton>
                <IconButton
                  size="small"
                  aria-label="next"
                  onClick={handleNext}
                  disabled={slideConfig.isEnd}
                  sx={{
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.secondary.main,
                    "&:hover": {
                      backgroundColor: theme.palette.primary.main,
                    },
                    "&:disabled": {
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.secondary.main,
                      opacity: 0.4,
                    },
                  }}
                >
                  <i className="fi fi-rr-arrow-small-right" />
                </IconButton>
              </Stack>
            </Container>
          )}
        </Stack>
        {openBackdrop && (
          <Backdrop
            offer={offer}
            open={openBackdrop}
            onClose={() => {
              handleChangeBackdrop(undefined);
            }}
          />
        )}
      </section>
    );
  }

  return <></>;
};

export default Catalog;
